export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CheckEndUserPasswordResetOtpInput = {
  resetOtp: Scalars['String']['input'];
};

export type CheckEndUserPasswordResetOtpPayload = {
  __typename?: 'CheckEndUserPasswordResetOtpPayload';
  isOtpValid: Scalars['Boolean']['output'];
};

export type CheckEndUserSignUpOtpInput = {
  signUpOtp: Scalars['String']['input'];
};

export type CheckEndUserSignUpOtpPayload = {
  __typename?: 'CheckEndUserSignUpOtpPayload';
  isOtpValid: Scalars['Boolean']['output'];
};

export type ClearMigrationWebhookSecretInput = {
  userStoreId: Scalars['String']['input'];
};

export type ClearMigrationWebhookSecretPayload = {
  __typename?: 'ClearMigrationWebhookSecretPayload';
  deletedSecret: Scalars['String']['output'];
};

export type ClearResetPasswordWebhookSecretInput = {
  userStoreId: Scalars['String']['input'];
};

export type ClearResetPasswordWebhookSecretPayload = {
  __typename?: 'ClearResetPasswordWebhookSecretPayload';
  deletedSecret: Scalars['String']['output'];
};

export type ClearUserSignUpWebhookSecretInput = {
  userStoreId: Scalars['String']['input'];
};

export type ClearUserSignUpWebhookSecretPayload = {
  __typename?: 'ClearUserSignUpWebhookSecretPayload';
  deletedSecret: Scalars['String']['output'];
};

export type CompleteEndUserPasswordResetInput = {
  newPassword: Scalars['String']['input'];
  resetOtp: Scalars['String']['input'];
};

export type CompleteEndUserPasswordResetPayload = {
  __typename?: 'CompleteEndUserPasswordResetPayload';
  idpUserId: Scalars['UUID']['output'];
};

export type CompleteEndUserSignUpInput = {
  /**
   * The password for the user must be provided either at this point or
   * in InitiateEndUserSignUp mutation.
   * If the end-user app will enforce the user to provide it in the
   * InitiateEndUserSignUp mutation the password must not be provided here.
   * If not, giving a password at this point is mandatory.
   * If it's given at InitiateEndUserSignUp step, then the used cannot override it here.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  signUpOtp: Scalars['String']['input'];
};

export type CompleteEndUserSignUpPayload = {
  __typename?: 'CompleteEndUserSignUpPayload';
  idpUserId: Scalars['UUID']['output'];
};

export type CompleteManagementUserPasswordResetInput = {
  newPassword: Scalars['String']['input'];
  resetOtp: Scalars['String']['input'];
};

export type CompleteManagementUserPasswordResetPayload = {
  __typename?: 'CompleteManagementUserPasswordResetPayload';
  idpUserId: Scalars['UUID']['output'];
};

export type CompleteManagementUserSignUpInput = {
  signUpOtp: Scalars['String']['input'];
};

export type CompleteManagementUserSignUpPayload = {
  __typename?: 'CompleteManagementUserSignUpPayload';
  idpUserId: Scalars['UUID']['output'];
};

/** All input for the create `EmailExclusionPattern` mutation. */
export type CreateEmailExclusionPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EmailExclusionPattern` to be created by this mutation. */
  emailExclusionPattern: EmailExclusionPatternInput;
};

/** The output of our create `EmailExclusionPattern` mutation. */
export type CreateEmailExclusionPatternPayload = {
  __typename?: 'CreateEmailExclusionPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailExclusionPattern` that was created by this mutation. */
  emailExclusionPattern?: Maybe<EmailExclusionPattern>;
  /** An edge for our `EmailExclusionPattern`. May be used by Relay 1. */
  emailExclusionPatternEdge?: Maybe<EmailExclusionPatternsEdge>;
  /** Reads a single `IdpUserStore` that is related to this `EmailExclusionPattern`. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EmailExclusionPattern` mutation. */
export type CreateEmailExclusionPatternPayloadEmailExclusionPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailExclusionPatternsOrderBy>>;
};

/** All input for the create `IdpUser` mutation. */
export type CreateIdpUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IdpUser` to be created by this mutation. */
  idpUser: IdpUserInput;
};

/** The output of our create `IdpUser` mutation. */
export type CreateIdpUserPayload = {
  __typename?: 'CreateIdpUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IdpUser` that was created by this mutation. */
  idpUser?: Maybe<IdpUser>;
  /** An edge for our `IdpUser`. May be used by Relay 1. */
  idpUserEdge?: Maybe<IdpUsersEdge>;
  /** Reads a single `IdpUserStore` that is related to this `IdpUser`. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IdpUser` mutation. */
export type CreateIdpUserPayloadIdpUserEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpUsersOrderBy>>;
};

/** All input for the create `IdpUserStore` mutation. */
export type CreateIdpUserStoreInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IdpUserStore` to be created by this mutation. */
  idpUserStore: IdpUserStoreInput;
};

/** The output of our create `IdpUserStore` mutation. */
export type CreateIdpUserStorePayload = {
  __typename?: 'CreateIdpUserStorePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IdpUserStore` that was created by this mutation. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** An edge for our `IdpUserStore`. May be used by Relay 1. */
  idpUserStoreEdge?: Maybe<IdpUserStoresEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IdpUserStore` mutation. */
export type CreateIdpUserStorePayloadIdpUserStoreEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpUserStoresOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteEmailExclusionPattern` mutation. */
export type DeleteEmailExclusionPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `EmailExclusionPattern` mutation. */
export type DeleteEmailExclusionPatternPayload = {
  __typename?: 'DeleteEmailExclusionPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailExclusionPattern` that was deleted by this mutation. */
  emailExclusionPattern?: Maybe<EmailExclusionPattern>;
  /** An edge for our `EmailExclusionPattern`. May be used by Relay 1. */
  emailExclusionPatternEdge?: Maybe<EmailExclusionPatternsEdge>;
  /** Reads a single `IdpUserStore` that is related to this `EmailExclusionPattern`. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EmailExclusionPattern` mutation. */
export type DeleteEmailExclusionPatternPayloadEmailExclusionPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailExclusionPatternsOrderBy>>;
};

export type DeleteIdpUserByEmailInput = {
  email: Scalars['String']['input'];
  userStoreId: Scalars['String']['input'];
};

export type DeleteIdpUserByEmailPayload = {
  __typename?: 'DeleteIdpUserByEmailPayload';
  idpUser?: Maybe<IdpUser>;
};

/** All input for the `deleteIdpUser` mutation. */
export type DeleteIdpUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `IdpUser` mutation. */
export type DeleteIdpUserPayload = {
  __typename?: 'DeleteIdpUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IdpUser` that was deleted by this mutation. */
  idpUser?: Maybe<IdpUser>;
  /** An edge for our `IdpUser`. May be used by Relay 1. */
  idpUserEdge?: Maybe<IdpUsersEdge>;
  /** Reads a single `IdpUserStore` that is related to this `IdpUser`. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IdpUser` mutation. */
export type DeleteIdpUserPayloadIdpUserEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpUsersOrderBy>>;
};

/** All input for the `deleteIdpUserStore` mutation. */
export type DeleteIdpUserStoreInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `IdpUserStore` mutation. */
export type DeleteIdpUserStorePayload = {
  __typename?: 'DeleteIdpUserStorePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IdpUserStore` that was deleted by this mutation. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** An edge for our `IdpUserStore`. May be used by Relay 1. */
  idpUserStoreEdge?: Maybe<IdpUserStoresEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IdpUserStore` mutation. */
export type DeleteIdpUserStorePayloadIdpUserStoreEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpUserStoresOrderBy>>;
};

export type DeleteOAuthClientInput = {
  clientId: Scalars['String']['input'];
  userStoreId: Scalars['UUID']['input'];
};

export type DeleteOAuthClientPayload = {
  __typename?: 'DeleteOAuthClientPayload';
  success: Scalars['Boolean']['output'];
};

export type EmailExclusionPattern = {
  __typename?: 'EmailExclusionPattern';
  affectedUserCount: Scalars['Int']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  emailPattern: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `IdpUserStore` that is related to this `EmailExclusionPattern`. */
  idpUserStore?: Maybe<IdpUserStore>;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  userStoreId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `EmailExclusionPattern` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EmailExclusionPatternCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailPattern` field. */
  emailPattern?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userStoreId` field. */
  userStoreId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `EmailExclusionPattern` object types. All fields are combined with a logical ‘and.’ */
export type EmailExclusionPatternFilter = {
  /** Filter by the object’s `affectedUserCount` field. */
  affectedUserCount?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmailExclusionPatternFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailPattern` field. */
  emailPattern?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idpUserStore` relation. */
  idpUserStore?: InputMaybe<IdpUserStoreFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmailExclusionPatternFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmailExclusionPatternFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userStoreId` field. */
  userStoreId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `EmailExclusionPattern` */
export type EmailExclusionPatternInput = {
  emailPattern: Scalars['String']['input'];
  environmentId: Scalars['UUID']['input'];
  userStoreId: Scalars['UUID']['input'];
};

/** Represents an update to a `EmailExclusionPattern`. Fields that are set will be updated. */
export type EmailExclusionPatternPatch = {
  emailPattern?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `EmailExclusionPattern` values. */
export type EmailExclusionPatternsConnection = {
  __typename?: 'EmailExclusionPatternsConnection';
  /** A list of edges which contains the `EmailExclusionPattern` and cursor to aid in pagination. */
  edges: Array<EmailExclusionPatternsEdge>;
  /** A list of `EmailExclusionPattern` objects. */
  nodes: Array<EmailExclusionPattern>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmailExclusionPattern` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EmailExclusionPattern` edge in the connection. */
export type EmailExclusionPatternsEdge = {
  __typename?: 'EmailExclusionPatternsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EmailExclusionPattern` at the end of the edge. */
  node: EmailExclusionPattern;
};

/** Methods to use when ordering `EmailExclusionPattern`. */
export enum EmailExclusionPatternsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EmailPatternAsc = 'EMAIL_PATTERN_ASC',
  EmailPatternDesc = 'EMAIL_PATTERN_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserStoreIdAsc = 'USER_STORE_ID_ASC',
  UserStoreIdDesc = 'USER_STORE_ID_DESC'
}

export type EnvironmentClientMapping = {
  __typename?: 'EnvironmentClientMapping';
  clientId: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  /** Reads a single `IdpUserStore` that is related to this `EnvironmentClientMapping`. */
  idpUserStore?: Maybe<IdpUserStore>;
  idpUserStoreId: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `EnvironmentClientMapping` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type EnvironmentClientMappingCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `idpUserStoreId` field. */
  idpUserStoreId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `EnvironmentClientMapping` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentClientMappingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentClientMappingFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idpUserStore` relation. */
  idpUserStore?: InputMaybe<IdpUserStoreFilter>;
  /** Filter by the object’s `idpUserStoreId` field. */
  idpUserStoreId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentClientMappingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentClientMappingFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `EnvironmentClientMapping` values. */
export type EnvironmentClientMappingsConnection = {
  __typename?: 'EnvironmentClientMappingsConnection';
  /** A list of edges which contains the `EnvironmentClientMapping` and cursor to aid in pagination. */
  edges: Array<EnvironmentClientMappingsEdge>;
  /** A list of `EnvironmentClientMapping` objects. */
  nodes: Array<EnvironmentClientMapping>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EnvironmentClientMapping` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EnvironmentClientMapping` edge in the connection. */
export type EnvironmentClientMappingsEdge = {
  __typename?: 'EnvironmentClientMappingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentClientMapping` at the end of the edge. */
  node: EnvironmentClientMapping;
};

/** Methods to use when ordering `EnvironmentClientMapping`. */
export enum EnvironmentClientMappingsOrderBy {
  ClientIdAsc = 'CLIENT_ID_ASC',
  ClientIdDesc = 'CLIENT_ID_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdpUserStoreIdAsc = 'IDP_USER_STORE_ID_ASC',
  IdpUserStoreIdDesc = 'IDP_USER_STORE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC'
}

export type GenerateMigrationWebhookSecretInput = {
  userStoreId: Scalars['String']['input'];
};

export type GenerateMigrationWebhookSecretPayload = {
  __typename?: 'GenerateMigrationWebhookSecretPayload';
  secret: Scalars['String']['output'];
};

export type GenerateOAuthClientSecretInput = {
  clientId: Scalars['String']['input'];
};

export type GenerateOAuthClientSecretPayload = {
  __typename?: 'GenerateOAuthClientSecretPayload';
  newClientSecret: Scalars['String']['output'];
};

export type GenerateResetPasswordWebhookSecretInput = {
  userStoreId: Scalars['String']['input'];
};

export type GenerateResetPasswordWebhookSecretPayload = {
  __typename?: 'GenerateResetPasswordWebhookSecretPayload';
  secret: Scalars['String']['output'];
};

export type GenerateUserSignUpWebhookSecretInput = {
  userStoreId: Scalars['String']['input'];
};

export type GenerateUserSignUpWebhookSecretPayload = {
  __typename?: 'GenerateUserSignUpWebhookSecretPayload';
  secret: Scalars['String']['output'];
};

export type IdpUser = {
  __typename?: 'IdpUser';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  environmentId: Scalars['UUID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads a single `IdpUserStore` that is related to this `IdpUser`. */
  idpUserStore?: Maybe<IdpUserStore>;
  idpUserStoreId: Scalars['UUID']['output'];
  isAffectedByExclusionPattern: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
};

/** A condition to be used against `IdpUser` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type IdpUserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `emailVerified` field. */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `idpUserStoreId` field. */
  idpUserStoreId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `isAffectedByExclusionPattern` field. */
  isAffectedByExclusionPattern?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `profilePictureUrl` field. */
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<UserStatus>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `IdpUser` object types. All fields are combined with a logical ‘and.’ */
export type IdpUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IdpUserFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailVerified` field. */
  emailVerified?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idpUserStore` relation. */
  idpUserStore?: InputMaybe<IdpUserStoreFilter>;
  /** Filter by the object’s `idpUserStoreId` field. */
  idpUserStoreId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isAffectedByExclusionPattern` field. */
  isAffectedByExclusionPattern?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IdpUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IdpUserFilter>>;
  /** Filter by the object’s `phoneNumber` field. */
  phoneNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `profilePictureUrl` field. */
  profilePictureUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<UserStatusFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `IdpUser` */
export type IdpUserInput = {
  email: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idpUserStoreId: Scalars['UUID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  passwordHash: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

/** Represents an update to a `IdpUser`. Fields that are set will be updated. */
export type IdpUserPatch = {
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idpUserStoreId?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export type IdpUserStore = {
  __typename?: 'IdpUserStore';
  category: UserStoreCategory;
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `EmailExclusionPattern`. */
  emailExclusionPatterns: EmailExclusionPatternsConnection;
  enforceStrictPasswordPolicy: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `EnvironmentClientMapping`. */
  environmentClientMappings: EnvironmentClientMappingsConnection;
  environmentId: Scalars['UUID']['output'];
  forgotPasswordWebhook?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `IdpUser`. */
  idpUsers: IdpUsersConnection;
  migrationWebhook?: Maybe<Scalars['String']['output']>;
  migrationWebhookSecretIsSet: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  resetPasswordWebhookSecretIsSet: Scalars['Boolean']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  userSignUpWebhook?: Maybe<Scalars['String']['output']>;
  userSignUpWebhookSecretIsSet: Scalars['Boolean']['output'];
};


export type IdpUserStoreEmailExclusionPatternsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailExclusionPatternCondition>;
  filter?: InputMaybe<EmailExclusionPatternFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailExclusionPatternsOrderBy>>;
};


export type IdpUserStoreEnvironmentClientMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentClientMappingCondition>;
  filter?: InputMaybe<EnvironmentClientMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentClientMappingsOrderBy>>;
};


export type IdpUserStoreIdpUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdpUserCondition>;
  filter?: InputMaybe<IdpUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdpUsersOrderBy>>;
};

/**
 * A condition to be used against `IdpUserStore` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IdpUserStoreCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UserStoreCategory>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `enforceStrictPasswordPolicy` field. */
  enforceStrictPasswordPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `forgotPasswordWebhook` field. */
  forgotPasswordWebhook?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `migrationWebhook` field. */
  migrationWebhook?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `migrationWebhookSecretIsSet` field. */
  migrationWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `resetPasswordWebhookSecretIsSet` field. */
  resetPasswordWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userSignUpWebhook` field. */
  userSignUpWebhook?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userSignUpWebhookSecretIsSet` field. */
  userSignUpWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `IdpUserStore` object types. All fields are combined with a logical ‘and.’ */
export type IdpUserStoreFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IdpUserStoreFilter>>;
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UserStoreCategoryFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `emailExclusionPatterns` relation. */
  emailExclusionPatterns?: InputMaybe<IdpUserStoreToManyEmailExclusionPatternFilter>;
  /** Some related `emailExclusionPatterns` exist. */
  emailExclusionPatternsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `enforceStrictPasswordPolicy` field. */
  enforceStrictPasswordPolicy?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environmentClientMappings` relation. */
  environmentClientMappings?: InputMaybe<IdpUserStoreToManyEnvironmentClientMappingFilter>;
  /** Some related `environmentClientMappings` exist. */
  environmentClientMappingsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `forgotPasswordWebhook` field. */
  forgotPasswordWebhook?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `idpUsers` relation. */
  idpUsers?: InputMaybe<IdpUserStoreToManyIdpUserFilter>;
  /** Some related `idpUsers` exist. */
  idpUsersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `migrationWebhook` field. */
  migrationWebhook?: InputMaybe<StringFilter>;
  /** Filter by the object’s `migrationWebhookSecretIsSet` field. */
  migrationWebhookSecretIsSet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IdpUserStoreFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IdpUserStoreFilter>>;
  /** Filter by the object’s `resetPasswordWebhookSecretIsSet` field. */
  resetPasswordWebhookSecretIsSet?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userSignUpWebhook` field. */
  userSignUpWebhook?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userSignUpWebhookSecretIsSet` field. */
  userSignUpWebhookSecretIsSet?: InputMaybe<BooleanFilter>;
};

/** An input for mutations affecting `IdpUserStore` */
export type IdpUserStoreInput = {
  category?: InputMaybe<UserStoreCategory>;
  enforceStrictPasswordPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  forgotPasswordWebhook?: InputMaybe<Scalars['String']['input']>;
  migrationWebhook?: InputMaybe<Scalars['String']['input']>;
  migrationWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  resetPasswordWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
  userSignUpWebhook?: InputMaybe<Scalars['String']['input']>;
  userSignUpWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents an update to a `IdpUserStore`. Fields that are set will be updated. */
export type IdpUserStorePatch = {
  category?: InputMaybe<UserStoreCategory>;
  enforceStrictPasswordPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  forgotPasswordWebhook?: InputMaybe<Scalars['String']['input']>;
  migrationWebhook?: InputMaybe<Scalars['String']['input']>;
  migrationWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resetPasswordWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
  userSignUpWebhook?: InputMaybe<Scalars['String']['input']>;
  userSignUpWebhookSecretIsSet?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `EmailExclusionPattern` object types. All fields are combined with a logical ‘and.’ */
export type IdpUserStoreToManyEmailExclusionPatternFilter = {
  /** Every related `EmailExclusionPattern` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmailExclusionPatternFilter>;
  /** No related `EmailExclusionPattern` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmailExclusionPatternFilter>;
  /** Some related `EmailExclusionPattern` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmailExclusionPatternFilter>;
};

/** A filter to be used against many `EnvironmentClientMapping` object types. All fields are combined with a logical ‘and.’ */
export type IdpUserStoreToManyEnvironmentClientMappingFilter = {
  /** Every related `EnvironmentClientMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EnvironmentClientMappingFilter>;
  /** No related `EnvironmentClientMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EnvironmentClientMappingFilter>;
  /** Some related `EnvironmentClientMapping` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EnvironmentClientMappingFilter>;
};

/** A filter to be used against many `IdpUser` object types. All fields are combined with a logical ‘and.’ */
export type IdpUserStoreToManyIdpUserFilter = {
  /** Every related `IdpUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IdpUserFilter>;
  /** No related `IdpUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IdpUserFilter>;
  /** Some related `IdpUser` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IdpUserFilter>;
};

/** A connection to a list of `IdpUserStore` values. */
export type IdpUserStoresConnection = {
  __typename?: 'IdpUserStoresConnection';
  /** A list of edges which contains the `IdpUserStore` and cursor to aid in pagination. */
  edges: Array<IdpUserStoresEdge>;
  /** A list of `IdpUserStore` objects. */
  nodes: Array<IdpUserStore>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IdpUserStore` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IdpUserStore` edge in the connection. */
export type IdpUserStoresEdge = {
  __typename?: 'IdpUserStoresEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IdpUserStore` at the end of the edge. */
  node: IdpUserStore;
};

/** Methods to use when ordering `IdpUserStore`. */
export enum IdpUserStoresOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnforceStrictPasswordPolicyAsc = 'ENFORCE_STRICT_PASSWORD_POLICY_ASC',
  EnforceStrictPasswordPolicyDesc = 'ENFORCE_STRICT_PASSWORD_POLICY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  ForgotPasswordWebhookAsc = 'FORGOT_PASSWORD_WEBHOOK_ASC',
  ForgotPasswordWebhookDesc = 'FORGOT_PASSWORD_WEBHOOK_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MigrationWebhookAsc = 'MIGRATION_WEBHOOK_ASC',
  MigrationWebhookDesc = 'MIGRATION_WEBHOOK_DESC',
  MigrationWebhookSecretIsSetAsc = 'MIGRATION_WEBHOOK_SECRET_IS_SET_ASC',
  MigrationWebhookSecretIsSetDesc = 'MIGRATION_WEBHOOK_SECRET_IS_SET_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ResetPasswordWebhookSecretIsSetAsc = 'RESET_PASSWORD_WEBHOOK_SECRET_IS_SET_ASC',
  ResetPasswordWebhookSecretIsSetDesc = 'RESET_PASSWORD_WEBHOOK_SECRET_IS_SET_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserSignUpWebhookAsc = 'USER_SIGN_UP_WEBHOOK_ASC',
  UserSignUpWebhookDesc = 'USER_SIGN_UP_WEBHOOK_DESC',
  UserSignUpWebhookSecretIsSetAsc = 'USER_SIGN_UP_WEBHOOK_SECRET_IS_SET_ASC',
  UserSignUpWebhookSecretIsSetDesc = 'USER_SIGN_UP_WEBHOOK_SECRET_IS_SET_DESC'
}

/** A connection to a list of `IdpUser` values. */
export type IdpUsersConnection = {
  __typename?: 'IdpUsersConnection';
  /** A list of edges which contains the `IdpUser` and cursor to aid in pagination. */
  edges: Array<IdpUsersEdge>;
  /** A list of `IdpUser` objects. */
  nodes: Array<IdpUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IdpUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IdpUser` edge in the connection. */
export type IdpUsersEdge = {
  __typename?: 'IdpUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IdpUser` at the end of the edge. */
  node: IdpUser;
};

/** Methods to use when ordering `IdpUser`. */
export enum IdpUsersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EmailVerifiedAsc = 'EMAIL_VERIFIED_ASC',
  EmailVerifiedDesc = 'EMAIL_VERIFIED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdpUserStoreIdAsc = 'IDP_USER_STORE_ID_ASC',
  IdpUserStoreIdDesc = 'IDP_USER_STORE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PhoneNumberAsc = 'PHONE_NUMBER_ASC',
  PhoneNumberDesc = 'PHONE_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfilePictureUrlAsc = 'PROFILE_PICTURE_URL_ASC',
  ProfilePictureUrlDesc = 'PROFILE_PICTURE_URL_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type InitiateEndUserPasswordResetInput = {
  customData?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  oAuthClientId: Scalars['String']['input'];
};

export type InitiateEndUserPasswordResetPayload = {
  __typename?: 'InitiateEndUserPasswordResetPayload';
  idpUserId: Scalars['UUID']['output'];
};

export type InitiateEndUserSignUpInput = {
  customData?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oAuthClientId: Scalars['String']['input'];
  /**
   * The password for the user must be provided either at this point or
   * in CompleteEndUserSignUp mutation.
   * If the end-user app will enforce the user to provide it in the
   * CompleteEndUserSignUp mutation the password does not have to be provided here.
   * If not, giving a password at this point is mandatory.
   */
  password?: InputMaybe<Scalars['String']['input']>;
};

export type InitiateEndUserSignUpPayload = {
  __typename?: 'InitiateEndUserSignUpPayload';
  idpUserId: Scalars['UUID']['output'];
};

export type InitiateManagementUserPasswordResetInput = {
  email: Scalars['String']['input'];
  oAuthClientId: Scalars['String']['input'];
};

export type InitiateManagementUserPasswordResetPayload = {
  __typename?: 'InitiateManagementUserPasswordResetPayload';
  idpUserId: Scalars['UUID']['output'];
};

export type InitiateManagementUserSignUpInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  oAuthClientId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InitiateManagementUserSignUpPayload = {
  __typename?: 'InitiateManagementUserSignUpPayload';
  idpUserId: Scalars['UUID']['output'];
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Check End-User Password Reset Otp */
  checkEndUserPasswordResetOtp: CheckEndUserPasswordResetOtpPayload;
  /** Check End-User Sign Up Otp */
  checkEndUserSignUpOtp: CheckEndUserSignUpOtpPayload;
  clearMigrationWebhookSecret: ClearMigrationWebhookSecretPayload;
  clearResetPasswordWebhookSecret: ClearResetPasswordWebhookSecretPayload;
  clearUserSignUpWebhookSecret: ClearUserSignUpWebhookSecretPayload;
  /** Complete End-User Reset Password Flow */
  completeEndUserPasswordReset: CompleteEndUserPasswordResetPayload;
  /** Start Sign Up as an End-User */
  completeEndUserSignUp: CompleteEndUserSignUpPayload;
  /** Complete Management-User Reset Password Flow */
  completeManagementUserPasswordReset: CompleteManagementUserPasswordResetPayload;
  /** Complete Management-User Sign Up Flow */
  completeManagementUserSignUp: CompleteManagementUserSignUpPayload;
  /** Creates a single `EmailExclusionPattern`. */
  createEmailExclusionPattern?: Maybe<CreateEmailExclusionPatternPayload>;
  /** Creates a single `IdpUser`. */
  createIdpUser?: Maybe<CreateIdpUserPayload>;
  /** Creates a single `IdpUserStore`. */
  createIdpUserStore?: Maybe<CreateIdpUserStorePayload>;
  /** Deletes a single `EmailExclusionPattern` using a unique key. */
  deleteEmailExclusionPattern?: Maybe<DeleteEmailExclusionPatternPayload>;
  /** Deletes a single `IdpUser` using a unique key. */
  deleteIdpUser?: Maybe<DeleteIdpUserPayload>;
  /** Delete User By Email */
  deleteIdpUserByEmail: DeleteIdpUserByEmailPayload;
  /** Deletes a single `IdpUserStore` using a unique key. */
  deleteIdpUserStore?: Maybe<DeleteIdpUserStorePayload>;
  /** Delete  OAuth Client */
  deleteOAuthClient: DeleteOAuthClientPayload;
  generateMigrationWebhookSecret: GenerateMigrationWebhookSecretPayload;
  /** Generate the client secret of an OAuth client */
  generateOAuthClientSecret: GenerateOAuthClientSecretPayload;
  generateResetPasswordWebhookSecret: GenerateResetPasswordWebhookSecretPayload;
  generateUserSignUpWebhookSecret: GenerateUserSignUpWebhookSecretPayload;
  /** Start End-User Reset Password Flow */
  initiateEndUserPasswordReset: InitiateEndUserPasswordResetPayload;
  /** Initiate Sign Up as an End-User */
  initiateEndUserSignUp: InitiateEndUserSignUpPayload;
  /** Start Management User Reset Password Flow */
  initiateManagementUserPasswordReset: InitiateManagementUserPasswordResetPayload;
  /** Initiate Sign Up as an Management User */
  initiateManagementUserSignUp: InitiateManagementUserSignUpPayload;
  /**
   * Silently provisions (create-if-absent) a migrated end-user in the given
   * AxAuth user store with no usable password (PASSWORD_NOT_SET) and returns
   * its AxAuth user id.
   */
  provisionMigratedEndUser: ProvisionMigratedEndUserPayload;
  /** Register OAuth Client */
  registerOAuthClient: RegisterOAuthClientPayload;
  /** Reset the password of an IDP user */
  resetIdpUserPassword: ResetIdpUserPasswordPayload;
  /** Updates a single `EmailExclusionPattern` using a unique key and a patch. */
  updateEmailExclusionPattern?: Maybe<UpdateEmailExclusionPatternPayload>;
  /** Updates a single `IdpUser` using a unique key and a patch. */
  updateIdpUser?: Maybe<UpdateIdpUserPayload>;
  /** Updates a single `IdpUserStore` using a unique key and a patch. */
  updateIdpUserStore?: Maybe<UpdateIdpUserStorePayload>;
  /** Update OAuth Client */
  updateOAuthClient: OAuthClientPayload;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckEndUserPasswordResetOtpArgs = {
  input?: InputMaybe<CheckEndUserPasswordResetOtpInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCheckEndUserSignUpOtpArgs = {
  input?: InputMaybe<CheckEndUserSignUpOtpInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearMigrationWebhookSecretArgs = {
  input: ClearMigrationWebhookSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearResetPasswordWebhookSecretArgs = {
  input: ClearResetPasswordWebhookSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationClearUserSignUpWebhookSecretArgs = {
  input: ClearUserSignUpWebhookSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteEndUserPasswordResetArgs = {
  input?: InputMaybe<CompleteEndUserPasswordResetInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteEndUserSignUpArgs = {
  input?: InputMaybe<CompleteEndUserSignUpInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteManagementUserPasswordResetArgs = {
  input?: InputMaybe<CompleteManagementUserPasswordResetInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteManagementUserSignUpArgs = {
  input?: InputMaybe<CompleteManagementUserSignUpInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmailExclusionPatternArgs = {
  input: CreateEmailExclusionPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIdpUserArgs = {
  input: CreateIdpUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIdpUserStoreArgs = {
  input: CreateIdpUserStoreInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmailExclusionPatternArgs = {
  input: DeleteEmailExclusionPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIdpUserArgs = {
  input: DeleteIdpUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIdpUserByEmailArgs = {
  input?: InputMaybe<DeleteIdpUserByEmailInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIdpUserStoreArgs = {
  input: DeleteIdpUserStoreInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOAuthClientArgs = {
  input: DeleteOAuthClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateMigrationWebhookSecretArgs = {
  input: GenerateMigrationWebhookSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateOAuthClientSecretArgs = {
  input?: InputMaybe<GenerateOAuthClientSecretInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateResetPasswordWebhookSecretArgs = {
  input: GenerateResetPasswordWebhookSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateUserSignUpWebhookSecretArgs = {
  input: GenerateUserSignUpWebhookSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateEndUserPasswordResetArgs = {
  input?: InputMaybe<InitiateEndUserPasswordResetInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateEndUserSignUpArgs = {
  input?: InputMaybe<InitiateEndUserSignUpInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateManagementUserPasswordResetArgs = {
  input?: InputMaybe<InitiateManagementUserPasswordResetInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateManagementUserSignUpArgs = {
  input?: InputMaybe<InitiateManagementUserSignUpInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationProvisionMigratedEndUserArgs = {
  input: ProvisionMigratedEndUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegisterOAuthClientArgs = {
  input: RegisterOAuthClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResetIdpUserPasswordArgs = {
  input?: InputMaybe<ResetIdpUserPasswordInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmailExclusionPatternArgs = {
  input: UpdateEmailExclusionPatternInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIdpUserArgs = {
  input: UpdateIdpUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIdpUserStoreArgs = {
  input: UpdateIdpUserStoreInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOAuthClientArgs = {
  input: UpdateOAuthClientInput;
};

export type OAuthClient = {
  __typename?: 'OAuthClient';
  allowUserSignUp?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['UUID']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idpUserStoreId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `OAuthClient` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OAuthClientCondition = {
  /** Checks for equality with the object’s `allowUserSignUp` field. */
  allowUserSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idpUserStoreId` field. */
  idpUserStoreId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `OAuthClient` object types. All fields are combined with a logical ‘and.’ */
export type OAuthClientFilter = {
  /** Filter by the object’s `allowUserSignUp` field. */
  allowUserSignUp?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OAuthClientFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idpUserStoreId` field. */
  idpUserStoreId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OAuthClientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OAuthClientFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

export type OAuthClientPayload = {
  __typename?: 'OAuthClientPayload';
  allowUserSignUp: Scalars['Boolean']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  redirectUris?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userStoreName: Scalars['String']['output'];
};

/** A connection to a list of `OAuthClient` values. */
export type OAuthClientsConnection = {
  __typename?: 'OAuthClientsConnection';
  /** A list of edges which contains the `OAuthClient` and cursor to aid in pagination. */
  edges: Array<OAuthClientsEdge>;
  /** A list of `OAuthClient` objects. */
  nodes: Array<OAuthClient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OAuthClient` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OAuthClient` edge in the connection. */
export type OAuthClientsEdge = {
  __typename?: 'OAuthClientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OAuthClient` at the end of the edge. */
  node: OAuthClient;
};

/** Methods to use when ordering `OAuthClient`. */
export enum OAuthClientsOrderBy {
  AllowUserSignUpAsc = 'ALLOW_USER_SIGN_UP_ASC',
  AllowUserSignUpDesc = 'ALLOW_USER_SIGN_UP_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdpUserStoreIdAsc = 'IDP_USER_STORE_ID_ASC',
  IdpUserStoreIdDesc = 'IDP_USER_STORE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type ProvisionMigratedEndUserInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The AxAuth user store the migrated identity is provisioned in. */
  idpUserStoreId: Scalars['UUID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisionMigratedEndUserPayload = {
  __typename?: 'ProvisionMigratedEndUserPayload';
  idpUserId: Scalars['UUID']['output'];
};

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  emailExclusionPattern?: Maybe<EmailExclusionPattern>;
  /** Reads and enables pagination through a set of `EmailExclusionPattern`. */
  emailExclusionPatterns?: Maybe<EmailExclusionPatternsConnection>;
  environmentClientMapping?: Maybe<EnvironmentClientMapping>;
  environmentClientMappingByClientId?: Maybe<EnvironmentClientMapping>;
  /** Reads and enables pagination through a set of `EnvironmentClientMapping`. */
  environmentClientMappings?: Maybe<EnvironmentClientMappingsConnection>;
  idpUser?: Maybe<IdpUser>;
  idpUserStore?: Maybe<IdpUserStore>;
  idpUserStoreByName?: Maybe<IdpUserStore>;
  /** Reads and enables pagination through a set of `IdpUserStore`. */
  idpUserStores?: Maybe<IdpUserStoresConnection>;
  /** Reads and enables pagination through a set of `IdpUser`. */
  idpUsers?: Maybe<IdpUsersConnection>;
  /** Get OAuth Client */
  oAuthClient: OAuthClientPayload;
  /** Reads and enables pagination through a set of `OAuthClient`. */
  oAuthClients?: Maybe<OAuthClientsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailExclusionPatternArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmailExclusionPatternsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EmailExclusionPatternCondition>;
  filter?: InputMaybe<EmailExclusionPatternFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EmailExclusionPatternsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentClientMappingArgs = {
  clientId: Scalars['String']['input'];
  environmentId: Scalars['UUID']['input'];
  idpUserStoreId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentClientMappingByClientIdArgs = {
  clientId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentClientMappingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentClientMappingCondition>;
  filter?: InputMaybe<EnvironmentClientMappingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentClientMappingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpUserArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpUserStoreArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpUserStoreByNameArgs = {
  environmentId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpUserStoresArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdpUserStoreCondition>;
  filter?: InputMaybe<IdpUserStoreFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdpUserStoresOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIdpUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IdpUserCondition>;
  filter?: InputMaybe<IdpUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IdpUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOAuthClientArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOAuthClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OAuthClientCondition>;
  filter?: InputMaybe<OAuthClientFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OAuthClientsOrderBy>>;
};

export type RegisterOAuthClientInput = {
  clientName: Scalars['String']['input'];
  userStoreId: Scalars['UUID']['input'];
};

export type RegisterOAuthClientPayload = {
  __typename?: 'RegisterOAuthClientPayload';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
};

export type ResetIdpUserPasswordInput = {
  id: Scalars['UUID']['input'];
};

export type ResetIdpUserPasswordPayload = {
  __typename?: 'ResetIdpUserPasswordPayload';
  idpUser?: Maybe<IdpUser>;
  newPassword: Scalars['String']['output'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateEmailExclusionPattern` mutation. */
export type UpdateEmailExclusionPatternInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `EmailExclusionPattern` being updated. */
  patch: EmailExclusionPatternPatch;
};

/** The output of our update `EmailExclusionPattern` mutation. */
export type UpdateEmailExclusionPatternPayload = {
  __typename?: 'UpdateEmailExclusionPatternPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EmailExclusionPattern` that was updated by this mutation. */
  emailExclusionPattern?: Maybe<EmailExclusionPattern>;
  /** An edge for our `EmailExclusionPattern`. May be used by Relay 1. */
  emailExclusionPatternEdge?: Maybe<EmailExclusionPatternsEdge>;
  /** Reads a single `IdpUserStore` that is related to this `EmailExclusionPattern`. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EmailExclusionPattern` mutation. */
export type UpdateEmailExclusionPatternPayloadEmailExclusionPatternEdgeArgs = {
  orderBy?: InputMaybe<Array<EmailExclusionPatternsOrderBy>>;
};

/** All input for the `updateIdpUser` mutation. */
export type UpdateIdpUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `IdpUser` being updated. */
  patch: IdpUserPatch;
};

/** The output of our update `IdpUser` mutation. */
export type UpdateIdpUserPayload = {
  __typename?: 'UpdateIdpUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IdpUser` that was updated by this mutation. */
  idpUser?: Maybe<IdpUser>;
  /** An edge for our `IdpUser`. May be used by Relay 1. */
  idpUserEdge?: Maybe<IdpUsersEdge>;
  /** Reads a single `IdpUserStore` that is related to this `IdpUser`. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IdpUser` mutation. */
export type UpdateIdpUserPayloadIdpUserEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpUsersOrderBy>>;
};

/** All input for the `updateIdpUserStore` mutation. */
export type UpdateIdpUserStoreInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `IdpUserStore` being updated. */
  patch: IdpUserStorePatch;
};

/** The output of our update `IdpUserStore` mutation. */
export type UpdateIdpUserStorePayload = {
  __typename?: 'UpdateIdpUserStorePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IdpUserStore` that was updated by this mutation. */
  idpUserStore?: Maybe<IdpUserStore>;
  /** An edge for our `IdpUserStore`. May be used by Relay 1. */
  idpUserStoreEdge?: Maybe<IdpUserStoresEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IdpUserStore` mutation. */
export type UpdateIdpUserStorePayloadIdpUserStoreEdgeArgs = {
  orderBy?: InputMaybe<Array<IdpUserStoresOrderBy>>;
};

export type UpdateOAuthClientInput = {
  allowUserSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['String']['input'];
  clientName?: InputMaybe<Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum UserStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Blocked */
  Blocked = 'BLOCKED'
}

/** A filter to be used against UserStatus fields. All fields are combined with a logical ‘and.’ */
export type UserStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserStatus>>;
};

export enum UserStoreCategory {
  /** End User */
  EndUser = 'END_USER',
  /** Management */
  Management = 'MANAGEMENT'
}

/** A filter to be used against UserStoreCategory fields. All fields are combined with a logical ‘and.’ */
export type UserStoreCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserStoreCategory>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserStoreCategory>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserStoreCategory>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserStoreCategory>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserStoreCategory>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserStoreCategory>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserStoreCategory>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserStoreCategory>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserStoreCategory>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserStoreCategory>>;
};
